import React from 'react';
import PropTypes from 'prop-types';

// This component used to provide consistency in Titles, whether it be a 
// table title, page title,  etc.
// Note that the defaults have been defined by destructuring the props
// argument below. The idea here is to have different types of titles, 
// such as a Table Title, Page Title, Image Title, etc, and be able to 
// switch up styles based on usage.

export const Title  = ({text = "", justify = "center", size = "medium", type="table"}) => {

    // Select style from _title.scss based on title type
    let style_type = "";
    switch (type) {
        case 'table':
            style_type = "table-title";
            break;
        default: 
            style_type = 'table-title';
    }

    return  <div className={style_type} >{text}</div>
};


Title.propTypes = {
    text:       PropTypes.string.isRequired,
    type:       PropTypes.string,
    size:       PropTypes.string,
    justify:    PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Title.js